export const en = {
    'error-get-revisions-description': 'Try again',
    'error-get-revisions-title': 'Couldn\'t load the list of versions',
    title: 'History of changes',
    'tooltip-compare': 'Add to comparison',
    'tooltip-current': 'Current version',
    'tooltip-del': 'Delete from comparison',
    'tooltip-old-editor': 'Version for old editor, not available for editing'
};
